import classNames from "classnames/dedupe";
import type { ComponentProps } from "react";
import type { WithMetadata } from "../../pages";
import { ExtraUKText } from "./ExtraUKText";
import { QuoteHeadline } from "./QuoteHeadline";
import { QuoteHeadlineWithBacklink } from "./QuoteHeadlineWithBacklink";
import { QuoteHeadlineWithEditlink } from "./QuoteHeadlineWithEditlink";
import type { HeadlineProps } from "./types";
import { useLocale } from "../../hooks/useLocale";

export const Headline = ({ ref, ...props }: WithMetadata<HeadlineProps>) => {
  const {
    className,
    componentName,
    quoteCount,
    variant = "control",
    phoneNumber,
    ...otherProps
  } = props;
  const classes = classNames("mobius", "mobius-quote-headline", className);

  const { isUK } = useLocale();
  const showExtraText = quoteCount > 0;
  const passProps = { ...otherProps, quoteCount };

  return (
    <div
      ref={ref}
      {...(componentName ? { "data-component": componentName } : {})}
      {...(variant ? { "data-variant": variant } : {})}
      className={classes}
    >
      {variant === "backlink" && (
        <QuoteHeadlineWithBacklink
          {...(passProps as ComponentProps<typeof QuoteHeadlineWithBacklink>)}
        />
      )}

      {variant === "editlink" && (
        <QuoteHeadlineWithEditlink
          {...(passProps as ComponentProps<typeof QuoteHeadlineWithBacklink>)}
        />
      )}

      {isUK && (
        <>
          <QuoteHeadline
            {...(passProps as ComponentProps<typeof QuoteHeadline>)}
          />
          {showExtraText && <ExtraUKText phoneNumber={phoneNumber} />}
        </>
      )}
    </div>
  );
};

Headline.displayName = "Headline";
